module.exports = __webpack_public_path__ + "media/images/lb/153-1e7911823c1b4872dcbba7448a38eff4.svg";